import styled from "@emotion/styled";
import { IconType } from "react-icons/lib";

export const styleChevron = (element: IconType) => styled(element)`
  height: 0.8em;
  cursor: pointer;
`;
